import Viewer from '@toast-ui/editor/viewer';

const ContentViewer = {
  mounted() {
    let theme = localStorage.getItem('hs_theme') || (document.querySelector('html').classList.contains('dark') ? 'dark' : 'light')

    this.viewer = new Viewer({
      el: this.el,
      hideModeSwitch: true,
      initialValue: this.el.innerHTML,
      viewer: true,
      theme: theme
    });
  },
  destroyed() {
    if (this.viewer) {
      this.viewer.destroy();
    }
  }
}

export default ContentViewer;
